import { InputComponent } from './input'
import * as DefaultComponents from './default'
import * as BMWComponents from './bmw'

export { InputComponent }

// One entry per brand folder that overrides form controls. A brand not listed
// renders DefaultComponents. Only the differing controls need to be exported.
export const BRAND_COMPONENT_OVERRIDES: Record<
  string,
  Partial<typeof DefaultComponents>
> = {
  bmw: BMWComponents,
}
